// The rows a SyncConnect query sends back (Admin › Platform › SyncConnect, the Toolkit's on-premise screens).
//
// Rows arrive as col1…colN in select-list order; SyncConnect sends the real names alongside as result.columns. A
// reply from an older SyncConnect has none, and the header falls back to col1…colN.

/** The colN keys present, in order — the widest of the names list and any row. */
export const columnsOf = (result) => {
    const rows = (result && result.rows) || [];
    let width = Array.isArray(result && result.columns) ? result.columns.length : 0;
    for (const r of rows) {
        for (const k of Object.keys(r || {})) {
            const m = /^col(\d+)$/.exec(k);
            if (m) width = Math.max(width, Number(m[1]));
        }
    }
    return Array.from({ length: width }, (_, i) => `col${i + 1}`);
};

/** The header for colN: the name SyncConnect read from Oracle, else colN itself. */
export const labelOf = (result, key) => {
    const names = result && Array.isArray(result.columns) ? result.columns : null;
    const n = Number(key.slice(3)) - 1;
    return (names && names[n]) || key;
};

/** The result as CSV text, header row first. */
export const toCsv = (result) => {
    const cols = columnsOf(result);
    const cell = (v) => {
        const s = v == null ? '' : String(v);
        return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    return [cols.map((c) => cell(labelOf(result, c))).join(','),
        ...((result && result.rows) || []).map((r) => cols.map((c) => cell(r[c])).join(','))].join('\r\n');
};
